import React, { useState } from 'react';

const slides = [
  {
    title: 'Instrucciones',
    content: (
      <div style={{ textAlign: 'left', padding: '0 10px' }}>
        <ol style={{ margin: 0, paddingLeft: 18 }}>
          <li>Cada hallazgo (punto de mantenimiento/justificación) deberá registrarse en el formulario.</li>
          <li>En caso de no identificar ningún hallazgo, se deberá subir un "Reporte de Segmento" por cada poste.</li>
          <li>Es obligatorio adjuntar <b>evidencia fotográfica</b>, tomada con <i>Open Camera</i> o <i>Canota</i>, que incluya los datos del técnico (Nombre completo, Usuario FC, hora y fecha, clúster, coordenadas).</li>
        </ol>
      </div>
    )
  },
  {
    title: 'Guía de Capacitación',
    content: (
      <div style={{ textAlign: 'center', padding: '0 10px' }}>
        <p style={{ marginBottom: 8 }}>Consulta la guía visual y videos de capacitación:</p>
        <a href="https://guia.analisisoperativo.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#007bff', fontWeight: 'bold', fontSize: '1.1em' }}>
          👉 Ir a la Guía de Capacitación
        </a>
      </div>
    )
  }
];

export default function InfoCarousel() {
  const [idx, setIdx] = useState(0);
  const next = () => setIdx((i) => (i + 1) % slides.length);
  const prev = () => setIdx((i) => (i - 1 + slides.length) % slides.length);

  return (
    <div style={{ background: '#f8f9fa', border: '2px solid #007bff', borderRadius: 12, margin: '10px 0 18px 0', padding: 0, boxShadow: '0 2px 12px rgba(0,0,0,0.07)' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', borderBottom: '1px solid #e3e3e3', background: '#e9f2ff', borderRadius: '12px 12px 0 0' }}>
        <button onClick={prev} style={{ background: 'none', border: 'none', fontSize: 22, color: '#007bff', cursor: 'pointer', padding: 0 }} aria-label="Anterior">◀</button>
        <span style={{ fontWeight: 'bold', fontSize: '1.05em', color: '#007bff' }}>{slides[idx].title}</span>
        <button onClick={next} style={{ background: 'none', border: 'none', fontSize: 22, color: '#007bff', cursor: 'pointer', padding: 0 }} aria-label="Siguiente">▶</button>
      </div>
      <div style={{ minHeight: 70, padding: '16px 0', background: 'white', borderRadius: '0 0 12px 12px' }}>
        {slides[idx].content}
      </div>
    </div>
  );
}
